import AContainer from "../../library/ExtendedObjects/AContainer.js";

export default class BonusBanner extends AContainer
{
    constructor(scene, x, y)
    {
        super(scene, x, y);
        this.scene.add.existing(this);

        this.bg = this.scene.addRect(-this.scene.mid.x, -55, this.scene.size.width, 110, 0xFCD638, this);
        this.bgShadow = this.scene.addRect(-this.scene.mid.x, 55, this.scene.size.width, 8, 0x000000, this);
        this.bgShadow.setAlpha(.4);

        this.shimmers = [];
        this.createShimmer(-90, -200, 0);
        this.createShimmer(-30, -200, 80);

        this.title = this.create(0, 0, "CtchCns");

        this.shines = [];
        this.createShine(-490, -30);
        this.createShine(490, 30);

        this.animationTimer = this.scene.addRepeatingEvent(5000, ()=>{
            this.animateBanner();
        });
        this.animateBanner();
    }

    destroy()
    {
        this.animationTimer.destroy();
        super.destroy();
    }

    animateBanner()
    {
        this.shimmers.forEach((shimmer)=>{
            shimmer.x = -800 + shimmer.xOffset;
            this.scene.addTween(shimmer, 2000, {x: shimmer.xOffset + 1200});
        });
        this.shines.forEach((shine)=>{
            shine.alpha = 0;
            this.scene.addTween(shine, 1000, {alpha: 1, yoyo: true, delay: (490 + shine.x)});
            this.scene.addTween(shine, 2000, {angle: 720, delay: (490 + shine.x)});
        });
    }

    createShine(x, y)
    {
        let shine = this.create(x, y, "sparkle_2");
        this.shines.push(shine);
    }

    createShimmer(width, tilt, xOffset)
    {
        let shimmer = this.scene.addPolygon(0, 0, [
            0, -55,
            width, -55,
            width + tilt, 55,
            tilt, 55
        ], 0xffffff, this);
        shimmer.alpha = .6;
        shimmer.xOffset = shimmer.x = xOffset;
        this.shimmers.push(shimmer);
    }
}